import type React from "react";
import {memo} from "react";

import type {OptionType} from "../Select";
import SelectGeneric from "../SelectGeneric";

type SelectDelayOption = OptionType<number>;

const minutes = [
    10,
    30,
    60,
    120,
    180,
    360,
    720,
    1440,
    1440 * 2,
    1440 * 3,
    1440 * 4,
    1440 * 5,
    1440 * 6,
    1440 * 7,
    1440 * 8,
    1440 * 9,
    1440 * 10
];

const options: SelectDelayOption[] = [
    {
        value: 0,
        label: "Within 5 Minutes"
    },
    ...minutes.map(item => {
        if (item <= 60) {
            return {
                value: item,
                label: `${item} Minutes After`
            };
        }
        if (item <= 1440) {
            return {
                value: item,
                label: `${item / 60} Hours After`
            };
        }
        return {
            value: item,
            label: `${item / 1440} Days After`
        };
    })
];

type Props = {
    value?: number;
    isDisabled?: boolean;
    onChange: (value: number) => void;
};

const SelectDelay: React.FC<Props> = ({value = 0, onChange, isDisabled}) => {
    return (
        <SelectGeneric
            isDisabled={isDisabled}
            options={options}
            placeholder="Delay..."
            testID="select-delay"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectDelay);
